import { render, staticRenderFns } from "./simInformation.vue?vue&type=template&id=3124a241&scoped=true"
import script from "./simInformation.vue?vue&type=script&lang=js"
export * from "./simInformation.vue?vue&type=script&lang=js"
import style0 from "./simInformation.vue?vue&type=style&index=0&id=3124a241&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3124a241",
  null
  
)

export default component.exports